import React, { useContext } from 'react';
import { useQuestionnaireStep } from './step_context';
import { isFeatureEnabled, FEATURES } from '../../helpers/feature_checker';

import Context from '../../utils/context';
import NewQuestionWrapper from '../../components/core/ui/question_wrapper';

import styles from './index.module.css';

const QuestionWrapper = ({
  children,
  onSubmit = () => {},
  onBack = () => {},
  isDisabled,
  showNavButtons = true,
  wide = false,
}) => {
  const context = useContext(Context);
  const account = context?.auth?.currentAccount ? context.auth.currentAccount() : null;
  const newUiEnabled = isFeatureEnabled(account, FEATURES.NEW_UI);
  const { current, total } = useQuestionnaireStep();

  if (newUiEnabled) {
    return (
      <NewQuestionWrapper
        current={current}
        total={total}
        onSubmit={onSubmit}
        onBack={onBack}
        isDisabled={isDisabled}
        showNavButtons={showNavButtons}
        wide={wide}
      >
        {children}
      </NewQuestionWrapper>
    );
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      // Pass the event to onSubmit, but also allow components to pass data through a custom property
      onSubmit(e);
    }
  };

  const handleBack = (e) => {
    e.preventDefault();
    if (onBack) {
      onBack(e);
    }
  };

  return (
    <div className='row'>
      <div className={wide ? 'col-sm-1' : 'col-sm-3'}></div>
      <div className={wide ? 'col-sm-10' : 'col-sm-6'}>
        <form id='plans' className={wide ? styles.form_wrapper_wide : styles.form_wrapper}>
          {children}
          {showNavButtons && (
            <div className={`row ${styles.button_holder}`}>
              {onBack && (
                <button className={`${styles.back} col-6`} type='button' onClick={handleBack}>
                  Back
                </button>
              )}
              <button
                disabled={`${isDisabled ? 'disabled' : ''}`}
                className={`${styles.submit} col-6`}
                type='submit'
                onClick={handleSubmit}
              >
                Next
              </button>
            </div>
          )}
        </form>
      </div>
      <div className={wide ? 'col-sm-1' : 'col-sm-3'}></div>
    </div>
  );
};

export default QuestionWrapper;
